<template>
  <div>
    <router-view v-if="isRender"></router-view>
    <div class="mod_loader" v-if="!isRender"><span class="loader"></span></div>
  </div>
</template>
<script>
import { getInitInfo } from 'src/vuex/actions'
import store from './vuex/store'
export default {
  replace: true,
  store,
  components: {},
  vuex: {
    actions: {
      getInitInfo
    }
  },
  data() {
    return {
      isRender: false
    }
  },
  ready() {
    if (this.$route.name === 'share') {
      this.isRender = true
    } else {
      this.client = window.HuobanAppSDK.client()
      this.client.on('error.connect', err => {
        // console.log('error.connect', err)
        this.isRender = true
        this.$router.go({name: 'error', query: {type: 'error', routerName: 'home'}})
      })
      this.client.init(11007).then(ret => {
        // console.log('init success', ret)
        this.isRender = true
        if (ret.table && ret.ticket) {
          this.getInitInfo(ret)
        } else {
          // let info = {
          //   keys: Object.keys(ret),
          //   app_title: ret.app.title,
          //   table_title: ret.table.title,
          //   isClient: window.HuobanAppSDK.isClient,
          //   isAndroid: window.HuobanAppSDK.isAndroid,
          //   isClientAndroid: window.HuobanAppSDK.isClientAndroid,
          //   cookie: document.cookie
          // }
          // alert('init error:' + JSON.stringify(info))
          this.$router.go({name: 'error', query: {type: 'error', routerName: 'home'}})
        }
      }).catch(err => {
        // console.log('init failed', err)
        let info = {
          err,
          isPC: window.HuobanAppSDK.isPC,
          isWap: window.HuobanAppSDK.isWap,
          isAndroid: window.HuobanAppSDK.isAndroid,
          isClient: window.HuobanAppSDK.isClient,
          cookie: document.cookie
        }
        alert('init fail:' + JSON.stringify(info))
        this.isRender = true
        this.$router.go({name: 'error', query: {type: 'error', routerName: 'home'}})
      })
    }
  }
}
</script>

<style src='./assets/css/app_todo.css'></style>



/** WEBPACK FOOTER **
 ** App.vue?307ef8b8
 **/